import { Thermostat } from '@mui/icons-material';
import { FC } from 'react';
import { useRecordContext } from 'react-admin';
import styles from './styles.module.scss';

export interface TemeratureFieldProps {
  source: string;
  label?: string;
}

export const TemperatureField: FC<TemeratureFieldProps> = ({
  source,
  label,
}) => {
  const getTemperature = (temperature: number) => {
    if (temperature >= 0.5) return '#c73319';
    if (temperature > 0.2) return '#c76719';
    if (temperature > 0.1) return '#dbce19';
    return '#1973db';
  };
  const record = useRecordContext({ label });
  return (
    record && (
      <div className={styles.TemperatureField}>
        <Thermostat style={{ color: getTemperature(record[source]) }} />
        {record[source]}
      </div>
    )
  );
};
